import { service } from '../../../../helpers/http' 

export const ActionDeleteSchedules = ({ dispatch }, payload) => {

    return service({
        module: 'domainSchedule',
        action: 'deleteSchedules',
        payload: payload
    })

}

export const ActionGetResolvedFeatures = ({ dispatch }, payload) => {

    return service({
        module: 'domainSchedule',
        action: 'getResolvedFeatures',
        payload: payload
    })

}

export const ActionPostSchedules = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'domainSchedule', 
		action: 'postSchedules', 
		payload: payload 
	})
}

export const ActionGetSchedules = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'domainSchedule', 
		action: 'getSchedules', 
		payload: payload 
	})
}

export const ActionDynamicGenerate = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'domainSchedule', 
		action: 'postDynamicGenerate', 
		payload: payload 
	})
}

export const ActionPostDates = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'domainSchedule', 
		action: 'postDates', 
		payload: payload 
	})
}

export const ActionDeleteScheduleByGrid = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'domainSchedule', 
		action: 'deleteSchedulesByGrid', 
		payload: payload 
	})
}

export const ActionDeleteScheduleByGroup = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'domainSchedule', 
		action: 'deleteSchedulesByGroup', 
		payload: payload 
	})
}